import React from 'react';
import { ButtonCircleBox } from './ButtonCircle.style';
import Tooltip from '@mui/material/Tooltip';

type TButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  typeSubmit: boolean;
  textToolTip?: string;
};
const ButtonCircle: React.FC<TButtonProps> = ({ onClick, disabled = false, label, typeSubmit, textToolTip = '' }) => {
  return (
    <>
      {typeSubmit ? (
        <Tooltip title={textToolTip} arrow>
          <ButtonCircleBox type="submit" disabled={disabled} onClick={onClick}>
            {label}
          </ButtonCircleBox>
        </Tooltip>
      ) : (
        <Tooltip title={textToolTip} arrow>
          <ButtonCircleBox disabled={disabled} onClick={onClick}>
            {label}
          </ButtonCircleBox>
        </Tooltip>
      )}
    </>
  );
};

export default ButtonCircle;
